import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent, ConfigurationService, LoggerService, SecurityService } from 'saker-core';
import { AuditSimpleLinkDTO } from 'src/app/Protocol/auditSimpleLink.dto';
import { NoteDTO } from 'src/app/Protocol/note.dto';
import { NoteService } from 'src/app/Service/note.service';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.css']
})
export class NoteComponent extends BaseComponent implements OnInit {

  //-------------------------------
  // Model
  //-------------------------------

  data: NoteDTO | null = null

  history: AuditSimpleLinkDTO[] = [];

  projectScenarioId = 0;
  noteId = 0;

  isCollapsed = true;
  isHistoryCollapsed = false;

  modify = false;
  modified = false;

  //-------------------------------
  // Behaviour
  //-------------------------------

  lines(item: string) {
    if (item) {
      item = String(item).replace(/<[^>]+>/gm, ''); // remove other html
      return item.replace(/(?:\r\n|\r|\n)/g, '<br>'); // repace line break with BR
    } else
      return
  }

  showProjectSummary() {
    this.router.navigate(["projectScenario/" + this.projectScenarioId])
  }

  saveNote() {
    console.dir(this.data);
    return this.noteService.saveNote(this.data)
      .subscribe((data) => {
        this.refreshData(data)
        this.modify = false
        this.modified = false
      });
  }

  deleteNote() {
    if (this.data) {
      this.data.deleted = true;
      return this.noteService.saveNote(this.data)
        .subscribe((data) => { this.refreshData(data) });
    } else
      return
  }

  detectChange() {
    this.changeDetector.detectChanges()
  }

  //-------------------------------
  // Private
  //-------------------------------

  private refreshData(id: string) {
    return this.noteService.getNote(id)
      .subscribe((data) => { this.storeData(data) });
  }

  private storeData(data: NoteDTO) {
    this.data = data;
    if (this.data.noteId == 0) {
      this.data = {
        noteId: 0,
        attachments: [],
        //@ts-ignore
        audit: {
          auditId: 0,
          auditNote: ''
        },
        deleted: false,
        //@ts-ignore
        projectScenario: {
          projectScenarioId: this.projectScenarioId
        }
      };
    }

    if (this.data) {
      this.refreshAuditTimeline(this.data.audit.auditId.toString());
      // this.data.dirty = false;
      // this.data.modify = false;
    }
  }

  private refreshAuditTimeline(auditId: string) {
    return this.noteService.getAuditTimeline(auditId)
      .subscribe((data) => { this.storeAuditTimeline(data) });
  }

  private storeAuditTimeline(data: AuditSimpleLinkDTO[]) {
    this.history = data;
  }

  //-------------------------------
  // Form
  //-------------------------------

  modalForm: any

  private setUp() {

    this.modalForm = new FormGroup({
      inputNote: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(2000)]),
    });

  }

  get inputNote() { return this.modalForm.get('inputNote'); }

  //-------------------------------
  // System
  //-------------------------------

  private activate() {

    this.activatedRoute.params.subscribe((params: Params) => {
      this.projectScenarioId = params['projectScenarioId']
      this.noteId = params['noteId']
    })

    this.refreshData(this.noteId.toString());

  }

  constructor(
    security: SecurityService,
    configuration: ConfigurationService,
    logger: LoggerService,
    router: Router,
    modal: NgbModal,
    changeDetectorRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private noteService: NoteService,
    private changeDetector: ChangeDetectorRef
  ) {
    super(security, configuration, logger, router, modal, changeDetectorRef);
  }

  ngOnInit(): void {
    this.activate()
    this.setUp()
  }

}
